module.exports = __webpack_public_path__ + "static/img/db.e046db35.svg";